import { render, staticRenderFns } from "./note-icon.vue?vue&type=template&id=9ea2f334"
import script from "./note-icon.vue?vue&type=script&lang=js"
export * from "./note-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ea2f334')) {
      api.createRecord('9ea2f334', component.options)
    } else {
      api.reload('9ea2f334', component.options)
    }
    module.hot.accept("./note-icon.vue?vue&type=template&id=9ea2f334", function () {
      api.rerender('9ea2f334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/note-icon.vue"
export default component.exports